import { Box, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { IoCloseCircle } from "react-icons/io5";
import { FaImage } from "react-icons/fa";
import ImageModal from "../Approval/Components/ImageModal";
import { useState } from "react";
import BackdropLoader from "../General/Loader";
import SnackBar from "../General/SnackBar";
import { GetImages } from "API/Misc/Documents";
import { IoIosCloseCircleOutline } from "react-icons/io";
import DeleteConfirmDialog from "./DeleteConfirmDialog";


const ViewAllFiles = (props) => {
    console.log("props at view all files", props);
    const [OpenImage, setOpenImage] = useState(false)
    const [ImageFile, setImageFile] = useState(null)
    const [ImageType, setImageType] = useState(null)
    const [IsLoading, setIsLoading] = useState(false)

    const [AlertMessage, setAlertMessage] = useState(null)
    const [AlertType, setAlertType] = useState(null)
    const [AlertOpen, setAlertOpen] = useState(false)
    const [OpenDeleteAlert,setOpenDeleteAlert] = useState({open:false,item:null})


    const handleOpenDeleteAlert=(item)=>{
        setOpenDeleteAlert({open:true,item:item})
    }

    const handleCloseDeleteAlert=()=>{
        setOpenDeleteAlert({open:false,item:null})
        
    }


    const handleAlertOpen = (message, type) => {
        setAlertMessage(message)
        setAlertType(type)
        setAlertOpen(true)
    }

    const handleAlertClose = () => {
        setAlertOpen(false)
        setAlertMessage(null)
        setAlertType(null)
    }

    const handleImageOpen = () => {
        setOpenImage(true)
    }

    const handleCloseImage = () => {
        setOpenImage(false)
    }

    const handleImageView = (item) => {
        GetImages(item, setIsLoading, handleAlertOpen, handleImageOpen, setImageType, setImageFile)
    }

    return (
        <Grid container spacing={2} p={2}>
            <SnackBar open={AlertOpen} handleClose={handleAlertClose} message={AlertMessage} type={AlertType} />
            <BackdropLoader open={IsLoading} />
            <ImageModal open={OpenImage} fileType={ImageType} image={ImageFile} handleClose={handleCloseImage} />
            <DeleteConfirmDialog handleGet={props.handleGet} field={props&&props?.field?.field_name} userId={props.userId} data={OpenDeleteAlert.item} open={OpenDeleteAlert.open} handleClose={handleCloseDeleteAlert} handleCloseMain={props.handleClose}/>
            <Box sx={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer", fontSize: '24px', zIndex: 10 }} onClick={props.handleClose}>
                <IoCloseCircle />
            </Box>
            <Grid item xs={12}>
                <Typography variant="h3">{props.field?.field_display_name}</Typography>
            </Grid>
            <Grid container mt={2} spacing={2}>
                {
                    props.value && Array.isArray(props.value) && props.value.length > 0 ? props.value.map((item, index) => (
                        <Grid item md={4} key={index} xs={12}>
                            <Box sx={{ position: "relative", backgroundColor: "#edf6f7", padding: '10px', borderRadius: '8px', cursor: "pointer" }} onClick={() => handleImageView(item)}>
                                <Box sx={{ 
                                    position: "absolute",
                                    top: '50%', 
                                    left: '90%', 
                                    transform: 'translate(-50%, -50%)', 
                                    fontSize: '28px' ,
                                    color:"grey",
                                    
                                    '&:hover':{
                                        color:"#ff0a1a"
                                    } 
                                }} onClick={(e) => {
                                    e.stopPropagation();
                                    handleOpenDeleteAlert(item)
                                }}>
                                    <IoIosCloseCircleOutline />
                                </Box>
                                <Stack direction="row" alignItems="center" gap={2}>
                                    <Box sx={{ 
                                        width: '60px', 
                                        height: '60px', 
                                        backgroundColor: '#fff', 
                                        borderRadius: '8px', 
                                        display: 'flex', 
                                        justifyContent: 'center', 
                                        alignItems: 'center', 
                                        fontSize: '20px',
                                        
                                        }}>
                                        <FaImage />
                                    </Box>
                                    <Typography variant='h5'>{item
                                        ? (() => {
                                            const text = item.split("-").splice(-3).join("");
                                            return text.length > 30 ? text.slice(20, text.length) : text;
                                        })()
                                        : ""}</Typography>
                                </Stack>
                            </Box>
                        </Grid>
                    ))
                        :
                        <Grid item xs={12}>
                            <Typography variant="h5">No files found</Typography>
                        </Grid>
                }

            </Grid>
        </Grid>
    );
}



export default ViewAllFiles;